import { useNavigate, useParams, useLocation } from "react-router-dom";
import { BsChevronLeft } from "react-icons/bs";
import { Tabbar } from "../compornents/Tabbar";
import { Analytics } from '../compornents/Analytics';

export const Order = () => {
  // order_id取得
  const params = useParams();
  const order_id = params.order_id;
  // {order_id: "1234"}
  console.log(order_id);
  const navigate = useNavigate();
  let location = useLocation();
  const order = location.state.order;
  // 戻る
  const back = () => {
    navigate(-1);
  };
  return (
    <div className="App">
      <div className="Order">
        <Analytics title="以前の注文詳細" />
        <div className="toolbar">
          <div className="toolbar_left div_btn" onClick={back} >
            <BsChevronLeft />
          </div>
          <div className="toolbar_center">
            以前の注文
          </div>
          <div className="toolbar_right">
          </div>
        </div>
        <div className="mt-3 mb-5">
          <div className="order_body mb-3">
            <div className="order_header mb-2">
              <div className={Number(order.otype) === 8 ? "order_status" : "order_status text-blue"} >
                {order.status_name}
              </div>
              <div className="order_date">
                ・{order.order_date}
              </div>
            </div>
            <div className="h4 mb-2">
              ご注文内容
            </div>
            <div className="content mb-4">
              <div className="row mb-2 border-bottom">
                <div className="col-8">
                  {order.item_name}
                </div>
                <div className="col-4 mb-2 text-right">
                  ￥{Number(order.kin).toLocaleString()}
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-8">
                  小計
                </div>
                <div className="col-4 text-right">
                  ￥{Number(order.kin).toLocaleString()}
                </div>
              </div>
              <div className="row mb-2 border-bottom">
                <div className="col-8">
                  Uber配達手数料
                </div>
                <div className="col-4 mb-2   text-right">
                  ￥{Number(order.uber_fee).toLocaleString()}
                </div>
              </div>
              <div className="row">
                <div className="col-6 h5">
                  合計
                </div>
                <div className="col-6 text-right h4">
                  ￥{Number(order.goukei).toLocaleString()}
                </div>
              </div>
            </div>
            <div className="h6 mb-1">お受渡し場所</div>
            <div className="mb-3">
              {order.pref + order.add1 + order.add2}<br />
              {order.add3}{order.room}
            </div>
          </div>
        </div>
        <Tabbar menu="orders" />
      </div>

    </div>
  );
}
